// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__aojQ_","rootMobile":"styles_rootMobile__3oWqH"};